import { render, staticRenderFns } from "./MsPopupV3.vue?vue&type=template&id=e0985c2a&scoped=true"
import script from "./MsPopupV3.vue?vue&type=script&lang=js"
export * from "./MsPopupV3.vue?vue&type=script&lang=js"
import style0 from "./MsPopupV3.vue?vue&type=style&index=0&id=e0985c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0985c2a",
  null
  
)

export default component.exports